function submitLiteSuggestion(suggestionData, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/suggestforpurchase/litesuggestions`;
  return apiClient.post(route, suggestionData);
}

export default {
  submitLiteSuggestion
};
